export function reactQueryGetErrorMessage(error: unknown) {
  /* istanbul ignore next */
  if (error instanceof Error) return error.message;
  return String(error);
}
